import { OrderType } from "models/pedidos/orderType";

export const isValidToShowInvoicesPdfFile = (sapOrderCode, orderType) =>
  !!sapOrderCode && orderType == OrderType.PurchaseOrder;
